// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:720px){.grooverInputWrapper .grooverTextInput[data-v-bff0df54]{min-height:70px}.grooverInnerWrap .picto.material-icons[data-v-bff0df54]{font-size:30px;top:calc(50% - 15px)}.controlArrows[data-v-bff0df54]{width:35px;height:70px}.controlArrows>div.material-icons[data-v-bff0df54]{font-size:35px}}", ""]);
// Exports
module.exports = exports;
